import axios from '../request/http';


const PlatformPartner = {
    //合伙人信息列表
    partnerList(params){
        return axios.get("/admin/partner/list", {params});
    },
    //合伙人订单列表
    partnerOrderList(params){
        return axios.get("/admin/partner/order/list", {params});
    },
    //合伙人订单分佣明细
    partnerRevenueDetail(params){
        return axios.get("/admin/partner/revenue/detail", {params});
    },
    //合伙人修改上级
    partnerUpdateBinding(params){
        return axios.get("/admin/partner/update/binding", {params});
    },
    //修改合伙人身份
    partnerUpdateLevel(params){
        return axios.get("/admin/partner/update/level", {params});
    },
    //查看分佣明细
    partnerRevenueDetail(params){
        return axios.get("/admin/partner/revenue/detail", {params});
    },
    //修改合伙人股票
    partnerUpdateTicket(params){
        return axios.get("/admin/partner/update/ticket", {params});
    },
    //合伙人统计
    partnerStatistics(params){
        return axios.get("/admin/partner/info/statistic", {params});
    },
    // 新建合伙人
    addPartner(params){
        return axios.get("/admin/partner/add/partner", {params});
    },
    // 合伙人开通店铺
    partnerOpenShop(params){
        return axios.get("/admin/partner/open/shop", {params});
    },
    // 合伙人记录列表 
    partnerTicketList(params){
        return axios.get("/admin/partner/ticket/list", {params});
    },
}

export default PlatformPartner;


// WEBPACK FOOTER //
// ./src/api/PlatformPartner.js